import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useNotification } from '../contexts/NotificationContext';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services/ApiService';
import '../styles/VerificarEmail.css';

const VerificarEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleLogoutAndRedirect = async () => {
    try {
      // Fazer logout da conta atual
      await logout();
      // Limpar qualquer dado de sessão armazenado
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      // Redirecionar para login
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      // Mesmo com erro, tentar redirecionar para login
      navigate('/login', { replace: true });
    }
  };

  useEffect(() => {
    const verificarEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('Token de verificação não encontrado');
        setLoading(false);
        // Redirecionar para login após 5 segundos em caso de erro
        setTimeout(handleLogoutAndRedirect, 5000);
        return;
      }

      try {
        const response = await fetch('https://verificaremail-jtoioxpfwq-uc.a.run.app', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token })
        });

        const data = await response.json();

        if (response.ok) {
          setSuccess(true);
          showNotification('Email verificado com sucesso!', 'success');
          // Fazer logout e redirecionar para login após sucesso
          handleLogoutAndRedirect();
        } else {
          setError(data.error || 'Erro ao verificar email');
          showNotification(data.error || 'Erro ao verificar email', 'error');
          // Redirecionar para login após 3 segundos em caso de erro
          setTimeout(handleLogoutAndRedirect, 3000);
        }
      } catch (err) {
        setError('Erro ao processar a verificação do email');
        showNotification('Erro ao processar a verificação do email', 'error');
        // Redirecionar para login após 3 segundos em caso de erro
        setTimeout(handleLogoutAndRedirect, 3000);
      } finally {
        setLoading(false);
      }
    };

    verificarEmail();
  }, [searchParams, navigate, showNotification, logout]);

  return (
    <div className="verificar-email-container">
      <div className="verificar-email-card">
        <h1>Verificação de Email</h1>
        
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Verificando seu email...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <i className="fas fa-exclamation-circle"></i>
            <p>{error}</p>
            <p>Você será redirecionado para a página de login...</p>
            <button 
              className="retry-button"
              onClick={handleLogoutAndRedirect}
            >
              Ir para Login
            </button>
          </div>
        )}

        {success && (
          <div className="success-container">
            <i className="fas fa-check-circle"></i>
            <p>Email verificado com sucesso!</p>
            <p>Redirecionando para a página de login...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificarEmail; 